import { getStorage, ref as getStorageRef, uploadBytesResumable } from "firebase/storage";
import { FIREBASE_APP } from "./app.js";

// Init.
const FIREBASE_STORAGE = getStorage(FIREBASE_APP);

/**
 * Upload a media file to Firebase Storage and call the `PUBLISH_MEDIA` API function to process it.
 *
 * @return Promise that resolves to the full string path of the uploaded file (including the prefix), or rejects to an error.
 * @throws Feedback If the file is invalid in some way that should be reported to the user.
 * @throws Error If the underlying storage upload fails in some way.
 */
export async function uploadStorageFile(file: File, path: `gs://${string}`, onProgress?: (progress: number, total: number) => void): Promise<void> {
	const ref = getStorageRef(FIREBASE_STORAGE, path);
	const task = uploadBytesResumable(ref, file);
	if (onProgress) task.on("state_changed", ({ bytesTransferred, totalBytes }) => onProgress(bytesTransferred, totalBytes));
	await task;
}
